import { useState, useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import WidgetsOutlinedIcon from "@mui/icons-material/WidgetsOutlined";
import SearchIcon from "@mui/icons-material/Search";
import CustomPagination from "../utils/paginationUtils";
import { RpaServices } from "../services/RpaServices";
import { handleApiErrorResponses } from "../utils/ApisErrorHandling";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";
const TmsLoginDetails = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [loginDetails, setLoginDetails] = useState(null);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const searchTimeRef = useRef(null);
  const limit = 10;
  const handleSearch = (e) => {
    if (searchTimeRef.current) {
      clearInterval(searchTimeRef.current);
    }
    searchTimeRef.current = setTimeout(() => {
      setSearchKey(e.target.value);
    }, 500);
  };

  const getCredentialDetails = async () => {
    setIsLoading(true);
    try {
      const res = await RpaServices.getTmsLoginCredentials(
        page,
        limit,
        searchKey
      );
      console.log("credential response data:", res?.data);
      setTotalPages(res?.data?.totalPages);
      setLoginDetails(res?.data?.userList);
    } catch (error) {
      handleApiErrorResponses(error);
    }
    setIsLoading(false);
  };
  useEffect(() => {
    getCredentialDetails();
  }, [page, searchKey]);
  return (
    <div className="initiateadmission-box">
      <span className="path_line">
        <WidgetsOutlinedIcon style={{ height: "24px" }} /> &nbsp;/ &nbsp;
        Dashboard &nbsp;/ &nbsp; TMS Login Details
      </span>{" "}
      <div className="flex justify-between items-center">
        <div className="heading">TMS Login Details</div>
        <div
          style={{ border: "1px solid #E4E4E4" }}
          className="flex gap-2 px-2 py-2 rounded-[8px] "
        >
          <SearchIcon />
          <input
            type="text"
            className="outline-none border-0"
            placeholder="Search Anything"
            onChange={handleSearch}
          />
        </div>
      </div>
      <div
        style={{
          border: "1px solid #E7E7E7",
          marginBottom: "20px",
        }}
      />{" "}
      {isLoading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div>
          {" "}
          <div className={`grid grid-cols-4  text-[#797979] text-[18px] px-8`}>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Hospital Name
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                Mobile Number
              </div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">CC Mobile</div>
            </div>
            <div>
              <div className="text-[#191919] font-semibold mb-4">
                RPA Mobile
              </div>
            </div>
          </div>
          {loginDetails && loginDetails?.length > 0 ? (
            loginDetails?.map((user, idx) => {
              return (
                <div
                  key={idx}
                  className={`py-6 px-8 rounded-[16px] ${
                    idx % 2 === 1 ? "bg-white" : "bg-[#F9F9F9]"
                  }`}
                >
                  <div
                    className={`grid grid-cols-4  text-[#797979] text-[18px] `}
                  >
                    <div>
                      <div>{user?.hospital?.name || "--"}</div>
                    </div>
                    <div>
                      <div>
                        {user?.phone || "--"}{" "}
                        {user?.phone && (
                          <ContentCopyIcon
                            className="cursor-pointer active:bg-slate-400 ml-2"
                            fontSize="12px"
                            onClick={() => {
                              navigator.clipboard.writeText(user?.phone);
                              toast.success(
                                "Mobile Number copied successfully"
                              );
                            }}
                          />
                        )}
                      </div>
                    </div>
                    <div>
                      {user?.hospital?.commandCenterCredentials?.length > 0
                        ? user?.hospital?.commandCenterCredentials?.map(
                            (cred, index) => {
                              return (
                                <div key={index}>
                                  {cred?.pmjayNumber || "--"}
                                  {cred?.pmjayNumber && (
                                    <ContentCopyIcon
                                      className="cursor-pointer active:bg-slate-400 ml-2"
                                      fontSize="12px"
                                      onClick={() => {
                                        navigator.clipboard.writeText(
                                          cred?.pmjayNumber
                                        );
                                        toast.success(
                                          "CC Credential Mobile Number copied successfully"
                                        );
                                      }}
                                    />
                                  )}
                                </div>
                              );
                            }
                          )
                        : "--"}
                    </div>
                    <div>
                      {user?.hospital?.rpaCredentials?.length > 0
                        ? user?.hospital?.rpaCredentials?.map((cred, index) => {
                            return (
                              <div key={index}>
                                {cred?.pmjayNumber}
                                {cred?.pmjayNumber && (
                                  <ContentCopyIcon
                                    className="cursor-pointer active:bg-slate-400 ml-2"
                                    fontSize="12px"
                                    onClick={() => {
                                      navigator.clipboard.writeText(
                                        cred?.pmjayNumber
                                      );
                                      toast.success(
                                        "RPA Credential Mobile Number copied successfully"
                                      );
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })
                        : "--"}
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="h-[300px] text-xl flex justify-center items-center font-semibold">
              No Details Found
            </div>
          )}
        </div>
      )}
      <div className="flex justify-center mt-8">
        <CustomPagination
          page={page}
          setPage={setPage}
          totalPages={totalPages}
        />
      </div>
    </div>
  );
};

export default TmsLoginDetails;
